import React from 'react';
import Resize from '@ali/arise-h5-utils-img';
import Styles from './index-pc.module.scss';

export default function Content({
  explanation,
  email,
  indication,
  imageUrl,
}: IContent) {
  return (
    <div className={Styles.content}>
      {imageUrl ? (
        <img
          className={Styles.contentImage}
          src={Resize.getFitUrl(imageUrl)}
        />
      ) : (
        <div className={Styles.contentDesc}>{explanation}</div>
      )}

      {!!email && (
        <div className="auto-c" data-spm="dEmail_square">
          <div className={Styles.contentIndication}>{indication}</div>
          <div className={Styles.contentEmail}>{email}</div>
        </div>
      )}
    </div>
  );
}

interface IContent {
  explanation: string;
  email?: string;
  indication?: string;
  imageUrl?: string;
}
